<template>
  <div class="LKRegMehView">
    <LkBackLink
      :to="backRoute"
      class="LKRegMehView__back"
    />

    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <div
      v-else-if="single"
      class="LKRegMehView__content"
    >
      <LKMunMehCard
        :data="single"
        active
        actionless
        :get-mun-meh="() => ({})"
      />
    </div>
  </div>
</template>

<script>
import { LkRegMehModel as Model } from './Model'
import { lkRegMehStoreModule as StoreModule } from './store'

import LkBackLink from '@/components/lk/LkBackLink.vue'
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKMunMehCard from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCard.vue'

import { LK_REG_MEH_ROUTES } from '@/views/LKRegMeh/utils'
import { createViewMixin } from '@/helpers/mixins/createViewMixin'

const mixinOptions = { Model, StoreModule }
const viewMixin = createViewMixin(mixinOptions)

export default {
  name: 'LKRegMehView',
  components: { LkBackLink, LKMunMehCard, LKProgressCircular },
  mixins: [viewMixin],
  data: () => ({
    backRoute: {
      name: LK_REG_MEH_ROUTES.LIST,
    },
  }),
  activated() {
    // когда created, то isLoadingAsyncData === true
    if (this.isLoadingAsyncData) return
    this.asyncData(true)
  },
}
</script>

<style lang="scss">
.LKRegMehView {
  &__back {
    margin-bottom: 10px;
  }

  &__content {
    font-size: 16px;
  }
}
</style>
